// ─── Masthare Estate — editable site content ────────────────────────────────
// Replace the PLACEHOLDER values below with your real details.

export const CONTACT = {
  name: "The Masthare Family",
  email: "Masthareestate@gmail.com",
  location: "Sakleshpur, Karnataka, India",
  // PLACEHOLDER phone number — replace with your real number (display form):
  phoneDisplay: "+91 90000 00000",
  // PLACEHOLDER WhatsApp number — country code + number, digits only:
  whatsapp: "919000000000",
  // PLACEHOLDER Instagram profile — replace with your real handle URL:
  instagram: "https://instagram.com/masthareestate",
};

export const NAV_LINKS = [
  { label: "Story", target: "story" },
  { label: "Grow", target: "grow" },
  { label: "Gallery", target: "land" },
  { label: "Contact", target: "contact" },
];

// Heritage timeline — edit these placeholder milestones freely.
export const TIMELINE = [
  {
    year: "1844",
    title: "The Estate is Founded",
    text: "The first coffee saplings are planted on these misty slopes in Sakleshpur.",
  },
  {
    year: "1910",
    title: "The Canopy is Kept",
    text: "While forests fall elsewhere, the estate chooses to grow beneath the native rainforest shade.",
  },
  {
    year: "1968",
    title: "A New Generation",
    text: "Pepper, arecanut and paddy join the coffee, as the family widens what the land gives.",
  },
  {
    year: "2026",
    title: "180 Years On",
    text: "Still family-run. Still shade-grown. Still patient.",
  },
];

export const IMAGES = {
  hero: {
    url: "https://images.unsplash.com/photo-1791217929551-4e6addc06818?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA6MDV8MHwxfHNlYXJjaHwxfHxtaXN0eSUyMGdyZWVuJTIwY29mZmVlJTIwcGxhbnRhdGlvbiUyMHdlc3Rlcm4lMjBnaGF0cyUyMG1vdW50YWlufGVufDB8fHx8MTc5MjUwODMyNXww&ixlib=rb-4.1.0&q=85",
    alt: "Misty green plantation slopes in the Western Ghats",
  },
  story: {
    url: "https://images.pexels.com/photos/13045091/pexels-photo-13045091.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Aerial view of rolling plantation hills in Karnataka",
  },
  gallery: [
    {
      url: "https://images.unsplash.com/photo-1779820553293-f61888bb5685?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHw0fHxjb2ZmZWUlMjBiZWFucyUyMHBsYW50JTIwc3BpY2VzJTIwcGVwcGVyJTIwdmluZSUyMHJhaW5mb3Jlc3QlMjBjYW5vcHl8ZW58MHx8fHwxNzkyNTA4MzI1fDA&ixlib=rb-4.1.0&q=85",
      alt: "Native rainforest canopy and shade trees over the estate",
      caption: "The canopy that shades us",
    },
    {
      url: "https://images.unsplash.com/photo-1788276363151-9edbb8129d0d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwyfHxyZWQlMjBjb2ZmZWUlMjBjaGVycmllcyUyMHBsYW50JTIwYnJhbmNofGVufDB8fHx8MTc5MjUwODMzMnww&ixlib=rb-4.1.0&q=85",
      alt: "Ripe red coffee cherries on the branch",
      caption: "Cherry season",
    },
    {
      url: "https://images.unsplash.com/photo-1761059373153-cd41f24be302?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwyfHxncmVlbiUyMHBhZGR5JTIwZmllbGRzJTIwbWlzdCUyMHRyZWVzfGVufDB8fHx8MTc5MjUwODMzMnww&ixlib=rb-4.1.0&q=85",
      alt: "Sunbeams filtering through morning mist on the estate",
      caption: "Morning mist",
    },
    {
      url: "https://images.pexels.com/photos/35459274/pexels-photo-35459274.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      alt: "Pepper vines climbing shade trees",
      caption: "Pepper on the climb",
    },
    {
      url: "https://images.unsplash.com/photo-1764260622561-d8cb451d5e46?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHw0fHxncmVlbiUyMHBhZGR5JTIwZmllbGRzJTIwbWlzdCUyMHRyZWVzfGVufDB8fHx8MTc5MjUwODMzMnww&ixlib=rb-4.1.0&q=85",
      alt: "Terraced paddy fields in a misty valley",
      caption: "Monsoon terraces",
    },
    {
      url: "https://images.unsplash.com/photo-1788002394652-2b946df12110?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwzfHxjb2ZmZWUlMjBiZWFucyUyMHBsYW50JTIwc3BpY2VzJTIwcGVwcGVyJTIwdmluZSUyMHJhaW5mb3Jlc3QlMjBjYW5vcHl8ZW58MHx8fHwxNzkyNTA4MzI1fDA&ixlib=rb-4.1.0&q=85",
      alt: "Tall palms and dense green canopy",
      caption: "Arecanut rows",
    },
  ],
};

export const MARQUEE_ITEMS = [
  "180 Years of Stewardship",
  "Shade-Grown Canopy",
  "Rainforest Harmony",
  "Sakleshpur Heritage",
  "Est. 1844",
  "Grown with Patience",
];

// Image manager slots (used by the /manage-images page)
export const IMAGE_SLOTS = [
  { key: "logo", label: "Logo", hint: "Replaces the text wordmark in the navbar and browser tab" },
  { key: "hero", label: "Hero Banner", hint: "The large misty photograph at the very top" },
  { key: "story", label: "Our Story Photo", hint: "The framed portrait in Our Story" },
  { key: "gallery_1", label: "Gallery Photo 1", hint: "Large photo, first row of The Land" },
  { key: "gallery_2", label: "Gallery Photo 2", hint: "Small photo, first row of The Land" },
  { key: "gallery_3", label: "Gallery Photo 3", hint: "Second row, left" },
  { key: "gallery_4", label: "Gallery Photo 4", hint: "Second row, middle" },
  { key: "gallery_5", label: "Gallery Photo 5", hint: "Second row, right" },
  { key: "gallery_6", label: "Gallery Photo 6", hint: "Wide photo, bottom row" },
];

export const DEFAULT_IMAGES = {
  hero: "https://images.unsplash.com/photo-1791217929551-4e6addc06818?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA6MDV8MHwxfHNlYXJjaHwxfHxtaXN0eSUyMGdyZWVuJTIwY29mZmVlJTIwcGxhbnRhdGlvbiUyMHdlc3Rlcm4lMjBnaGF0cyUyMG1vdW50YWlufGVufDB8fHx8MTc5MjUwODMyNXww&ixlib=rb-4.1.0&q=85",
  story: "https://images.pexels.com/photos/13045091/pexels-photo-13045091.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  gallery_1: "https://images.unsplash.com/photo-1779820553293-f61888bb5685?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHw0fHxjb2ZmZWUlMjBiZWFucyUyMHBsYW50JTIwc3BpY2VzJTIwcGVwcGVyJTIwdmluZSUyMHJhaW5mb3Jlc3QlMjBjYW5vcHl8ZW58MHx8fHwxNzkyNTA4MzI1fDA&ixlib=rb-4.1.0&q=85",
  gallery_2: "https://images.unsplash.com/photo-1788276363151-9edbb8129d0d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwyfHxyZWQlMjBjb2ZmZWUlMjBjaGVycmllcyUyMHBsYW50JTIwYnJhbmNofGVufDB8fHx8MTc5MjUwODMzMnww&ixlib=rb-4.1.0&q=85",
  gallery_3: "https://images.unsplash.com/photo-1761059373153-cd41f24be302?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwyfHxncmVlbiUyMHBhZGR5JTIwZmllbGRzJTIwbWlzdCUyMHRyZWVzfGVufDB8fHx8MTc5MjUwODMzMnww&ixlib=rb-4.1.0&q=85",
  gallery_4: "https://images.pexels.com/photos/35459274/pexels-photo-35459274.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  gallery_5: "https://images.unsplash.com/photo-1764260622561-d8cb451d5e46?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHw0fHxncmVlbiUyMHBhZGR5JTIwZmllbGRzJTIwbWlzdCUyMHRyZWVzfGVufDB8fHx8MTc5MjUwODMzMnww&ixlib=rb-4.1.0&q=85",
  gallery_6: "https://images.unsplash.com/photo-1788002394652-2b946df12110?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwzfHxjb2ZmZWUlMjBiZWFucyUyMHBsYW50JTIwc3BpY2VzJTIwcGVwcGVyJTIwdmluZSUyMHJhaW5mb3Jlc3QlMjBjYW5vcHl8ZW58MHx8fHwxNzkyNTA4MzI1fDA&ixlib=rb-4.1.0&q=85",
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
